import { render, staticRenderFns } from "./legend-document-list.vue?vue&type=template&id=3489fda0"
import script from "./legend-document-list.vue?vue&type=script&lang=js"
export * from "./legend-document-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports